import React, { Component } from "react";
import { Input, Row, Col } from "reactstrap";

import ArrangedDataView from "./ArrangedDataView";
import { Position, Drawer } from "@blueprintjs/core";

import config from "../../../variables/Constants";
import {
  Spinner,
  Icon,
  Button,
  Classes,
  Dialog,
  Tooltip,
} from "@blueprintjs/core";

import {
  getValue,
  getMCQQuestion,
  getPRACTICALQuestion,
  getSCENARIOQuestion,
} from "./helpers/util";

import { AppConfig } from "../../../config/config.js";
import withUseApiService from "../../../utils/withUseApiService.jsx";
var i3 = 0;
class PaperTypeByGoogle extends Component {
  constructor(props, context) {
    super(props, context);
    this.apiService = this.props.apiService;
    this.state = {
      signIn: false,
      visible: false,
      GoogleSheetID: "",
      RawData: null,
      loading: false,
      InOperation: false,
      OperationMessage: "",
      QuestionData: null,
      IsDataArranger: false,
      ArrangedData: null,
      dataInserting: false,
      IsErrorDataInsert: false,
      InsertErrorMessage: "",
      GoogleSheetIDError: true,
      GoogleSheetErrorMessage: "",
      // Handle Data Arrange Error
      ErrorDataArranger: false,
      ErrorMessageDateArrange: "",
      UpdatedValue: null,
    };
  }

  // Verify data  Operation Handle
  VerifyData = async () => {
    var VerifiedData = this.state.ArrangedData;
    this.setState({
      dataInserting: true,
    });
    this.apiService.getApiInstance()
      .post(
        AppConfig.serviceUrls.questionPool + '/' + VerifiedData.descriptionData.questionType,
        VerifiedData
      )
      .then((res) => {
        if (res.status === 201) {
          var data = [];
          for (const [googleSheetID, GenaratedID] of Object.entries(res.data.googleKeyMap)) {
            data.push({
              range: googleSheetID,
              values: [[GenaratedID]],
            });
          }
          var body = {
            data: data,
            valueInputOption: "USER_ENTERED",
          };

          this.apiService.getApiInstance()
            .patch(
              AppConfig.serviceUrls.questionPool + "?sheetId=" + this.state.GoogleSheetID,
              body
            )
            .then((res) => {
              if (res.status === 201) {
                this.props.handleHide();
                window.location.reload()
              } else {
                this.setState({ error: true, loading: false });
              }
            })
            .catch((err) => {
              this.setState({
                loading: false,
                error: true,
                time: Date(Date.now()),
              });
            });

          this.setState({
            dataInserting: false,
            IsErrorDataInsert: false,
            InsertErrorMessage: "",
          });

          //this.props.FetchPaperTypeData();
          this.props.Notification(
            "tr",
            "success",
            "Paper type data has been inserted successfully",
            "pe-7s-speaker"
          );
        } else {
          this.setState({
            dataInserting: false,
            IsErrorDataInsert: true,
            InsertErrorMessage: "Bad Request",
          });

          this.props.Notification(
            "tr",
            "error",
            "Error Message",
            "pe-7s-speaker"
          );
          this.reset();
        }
      })
      .catch(
        function (err) {
          this.setState({
            dataInserting: false,
            IsErrorDataInsert: true,
            InsertErrorMessage: "Error Capture",
          });

          this.props.Notification(
            "tr",
            "error",
            "Error Message",
            "pe-7s-speaker"
          );
          this.reset();
        }.bind(this)
      );
  };

  // event handler
  handleGoogleSheetIDChange = (evt) => {
    var matches = /\/([\w-_]{15,})\/(.*?gid=(\d+))?/.exec(evt.target.value);
    if (matches !== null) {
      this.setState({ GoogleSheetID: matches[1], GoogleSheetIDError: false });
    } else {
      this.setState({ GoogleSheetID: "", GoogleSheetIDError: true });
    }

  };

  componentDidMount() {
    this.setState({
      dataInserting: false,
      IsErrorDataInsert: false,
      GoogleSheetIDError: true,
    });

    this.setState({ visible: true });
    this.setState({ signIn: true });
  }

  stateSet = (state) => {
    this.setState({ signIn: state });
  };


  reset = () => {
    this.setState({
      GoogleSheetID: "",
      RawData: null,
      loading: false,
      InOperation: false,
      OperationMessage: "",
      QuestionData: null,
      IsDataArranger: false,
      ArrangedData: null,
      dataInserting: false,
      IsErrorDataInsert: false,
      InsertErrorMessage: "",
      GoogleSheetIDError: true,
      GoogleSheetErrorMessage: "",
      ErrorDataArranger: false,
      ErrorMessageDateArrange: "",
    });
  };

  fetchData = () => {
    this.callAfterLogin();
  };

  callAfterLogin = async () => {   
    this.setState({
      loading: true,
      OperationMessage: "Data Loading...",
      InOperation: true,
    });

    this.apiService.getApiInstance()
      .get(
        AppConfig.serviceUrls.questionPool + "?sheetId=" + this.state.GoogleSheetID
      )
      .then((res) => {
        if (res.status === 200) {
          this.setState({ RawData: res.data.sheets });
          this.DataOperationHandler();
          this.setState({ loading: false });
        } else {
          this.setState({ error: true, loading: false });
        }
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: true,
          time: Date(Date.now()),
        });
      });
  };

  DataOperationHandler = () => {
    let responce;
    this.setState({
      InOperation: true,
    });
    responce = this.DataValidation();
    if (responce instanceof Error) {
      this.setState({
        ErrorDataArranger: true,
        ErrorMessageDateArrange: responce.message,
      });
      return;
    }
    responce = this.DataArranger(responce);
    if (responce instanceof Error) {
      this.setState({
        ErrorDataArranger: true,
        ErrorMessageDateArrange: responce.message,
      });
      return;
    }
  };

  // Data Validations Operations
  DataValidation = () => {
    //set State Message
    this.setState({
      OperationMessage: "Data Validating... ",
    });
    //discription sheet Properties
    var disSheetProps = this.state.RawData[0].properties;
    if (this.state.RawData.length <= 1) {
      return new Error("No Data to Handle");
    }

    if (disSheetProps.title === "DESCRIPTION") {
      let VerifiedData = {};
      let disSheetData = this.state.RawData[0].data;
      // Capture Module Data
      let ModuleData = {
        ModuleID: this.props.moduleId,
        Version: this.props.Version,
      };
      // Capture Paper Data
      let descriptionData = {
        moduleId: parseInt(getValue(disSheetData, 2, 0), 10),
        moduleIdSheetId: disSheetProps.title + "!A3",
        moduleName: getValue(disSheetData, 2, 1),
        productId: parseInt(getValue(disSheetData, 4, 0), 10),
        productIdSheetId: disSheetProps.title + "!A5",
        productName: getValue(disSheetData, 4, 1),
        questionType: getValue(disSheetData, 4, 2),
        versions: [],
      };
      // Error check
      // if (this.props.ModuleName !== DescriptionData.ModuleName) {
      //   return new Error("Module Name is Not Match.");
      // }

      console.log("Description Data: ", descriptionData);
      console.log("Product Name: ", this.props);

      if (this.props.ProductName !== descriptionData.productName) {
        return new Error("Product Name is Not Match.");
      }
      if (this.props.QuestionType !== descriptionData.questionType) {
        return new Error(
          "This module can only handle " +
            this.props.QuestionType +
            " questions pool only. Check your paper question type."
        );
      }

      descriptionData.moduleId = this.props.moduleId;
      descriptionData.productId = this.props.productId;

      // capture VersionData
      for (let row = 0; ; row++) {
        if (getValue(disSheetData, 7 + row, 1) === null) {
          break;
        }
        let versionData = {
          versionId: parseInt(getValue(disSheetData, 7 + row, 0), 10),
          version: getValue(disSheetData, 7 + row, 1),
          sheetId: disSheetProps.title + "!A" + (row + 8),
        };
        descriptionData.versions[row] = versionData;
      }
      // pass for Error check
      // ---> Implement function for handle Error

      return descriptionData;
    } else {
      return new Error("Description Page Not Exist");
    }
  };

  // Data Arrange Operation
  DataArranger = (DescriptionData) => {
    let ArrangedData = {};
    // Similarity Data -------------------------------------------------------------
    let SimilarityData = [];
    var SimilaritySheetProps = this.state.RawData[1].properties;
    let SimilaritySheetData = this.state.RawData[1].data;
    if (SimilaritySheetProps.title === "SIMILARITY") {
      for (let row = 0; ; row++) {
        if (getValue(SimilaritySheetData, 1 + row, 1) === null) {
          break;
        }
        let TempSimilarity = {
          similarityId: parseInt(getValue(SimilaritySheetData, 1 + row, 0), 10),
          similarity: getValue(SimilaritySheetData, 1 + row, 1),
          sheetId: SimilaritySheetProps.title + "!A" + (row + 2),
        };
        SimilarityData[row] = TempSimilarity;
      }
    } else {
      return new Error("SIMILARITY Page Not Exist");
    }

    // catch Category Data------------------------------------------------------
    let CategoryData = [];
    var CategorySheetProps = this.state.RawData[2].properties;
    let CategorySheetData = this.state.RawData[2].data;
    if (CategorySheetProps.title === "CATEGORIES") {
      // catch Category Data
      for (let row = 0; ; row++) {
        if (getValue(CategorySheetData, 1 + row, 1) === null) {
          break;
        }
        let TempCategory = {
          categoryId: parseInt(getValue(CategorySheetData, 1 + row, 0), 10),
          category: getValue(CategorySheetData, 1 + row, 1),
          topics: [],
          sheetId: CategorySheetProps.title + "!A" + (row + 2),
        };
        CategoryData[row] = TempCategory;
      }
    } else {
      return new Error("CATEGORIES Page Not Exist");
    }

    // Catch Topic Data ------------------------------------------------------------
    var TopicsSheetProps = this.state.RawData[3].properties;
    let TopicsSheetData = this.state.RawData[3].data;
    if (TopicsSheetProps.title === "TOPICS") {
      for (let row = 0; ; row++) {
        if (getValue(TopicsSheetData, 1 + row, 1) === null) {
          break;
        }
        let TempTopics = {
          topicId: parseInt(getValue(TopicsSheetData, 1 + row, 0), 10),
          topic: getValue(TopicsSheetData, 1 + row, 2),
          sheetId: TopicsSheetProps.title + "!A" + (row + 2),
        };
        CategoryData.forEach((CategoryInstance) => {
          if (
            CategoryInstance.category === getValue(TopicsSheetData, 1 + row, 1)
          ) {
            CategoryInstance.topics.push(TempTopics);
          }
        });
      }
    } else {
      return new Error("TOPICS Page Not Exist");
    }

    // catch Question Pool
    let QuestionsData = [];
    let GroupData = [];
    var QuestionPoolProps = this.state.RawData[4].properties;
    let QuestionPoolData = this.state.RawData[4].data;
    if (QuestionPoolProps.title === "QUESTION_POOL") {
      let QuestionPointer = 0;
      for (let row = 1; ; row++) {
        if (getValue(QuestionPoolData, row, 2) === null) {
          break;
        }
        //MCQ Quesiton Arranging
        if (DescriptionData.questionType === "MCQ") {
          let TempQuestion = getMCQQuestion(
            QuestionPoolData,
            row,
            QuestionPoolProps.title
          );
          if (TempQuestion instanceof Error) {
            return TempQuestion;
          }
          // ADD THE QUESTION IF THE STATE IS NOT "CLOSE"
          if (TempQuestion.state !== "CLOSE") {
            QuestionsData[QuestionPointer] = TempQuestion;
            QuestionPointer++;
          }
          if (DescriptionData.productName === "Solutions Architecture") {
            var GropusSheetProps = this.state.RawData[5].properties;
            let GroupsSheetData = this.state.RawData[5].data;
            if (GropusSheetProps.title === "GROUPS") {
              for (let row = 0; ; row++) {
                if (getValue(GroupsSheetData, 1 + row, 1) === null) {
                  break;
                }
                let TempGroups = {
                  groupId: parseInt(getValue(GroupsSheetData, 1 + row, 0), 10),
                  group: getValue(GroupsSheetData, 1 + row, 1),
                  sheetId: GropusSheetProps.title + "!A" + (row + 2),
                };
                GroupData[row] = TempGroups;
              }
            }
          }
        }

        // Practical Question Arranging
        if (DescriptionData.questionType === "PRACTICAL") {
          let TempQuestion = getPRACTICALQuestion(
            QuestionPoolData,
            row,
            QuestionPoolProps.title
          );
          if (TempQuestion instanceof Error) {
            return TempQuestion;
          }
          if (TempQuestion.state !== "CLOSE") {
            QuestionsData[QuestionPointer] = TempQuestion;
            QuestionPointer++;
          }
        }

        // Scenario Base Quesiton Arranging
        if (DescriptionData.questionType === "SCENARIO_BASE") {
          let TempQuestion = getSCENARIOQuestion(
            QuestionPoolData,
            row,
            QuestionPoolProps.title
          );
          if (TempQuestion instanceof Error) {
            return TempQuestion;
          }
          if (TempQuestion.state !== "CLOSE") {
            QuestionsData[QuestionPointer] = TempQuestion;
            QuestionPointer++;
          }
        }
      }
    } else {
      return new Error("QUESTION_POOL Page Not Exist");
    }

    // Scenarios Data -------------------------------------------------------------
    let ScenariosData = [];
    if (DescriptionData.questionType === "SCENARIO_BASE") {
      var ScenarioSheetProps = this.state.RawData[5].properties;
      let ScenarioSheetData = this.state.RawData[5].data;
      if (ScenarioSheetProps.title === "SCENARIOS") {
        for (let row = 0; ; row++) {
          if (getValue(ScenarioSheetData, 1 + row, 1) === null) {
            break;
          }
          let TempScenario = {
            scenarioId: parseInt(getValue(ScenarioSheetData, 1 + row, 0), 10),
            scenario: getValue(ScenarioSheetData, 1 + row, 1),
            scenarioContent: getValue(ScenarioSheetData, 1 + row, 2),
            sheetId: ScenarioSheetProps.title + "!A" + (row + 2),
          };
          ScenariosData[row] = TempScenario;
        }

        ArrangedData["scenarioData"] = ScenariosData;
      } else {
        return new Error("SCENARIOS Page Not Exist");
      }
    }

    ArrangedData["descriptionData"] = DescriptionData;
    ArrangedData["similarityData"] = SimilarityData;
    ArrangedData["categoryData"] = CategoryData;
    if (DescriptionData.questionType === "MCQ") {
      ArrangedData["groupData"] = GroupData;
    }
    ArrangedData["questionData"] = QuestionsData;

    this.setState({
      OperationMessage: "Data was Arranged ",
    });
    this.setState({ ArrangedData: ArrangedData });
    this.setState({ IsDataArranger: true });
    return ArrangedData;
  };
  // Data Manager Operation Handle CRUD Operations
  DataManager = (ArrangedData) => {
    console.log(ArrangedData);
    this.setState({
      OperationMessage: "Data Uploading... ",
    });
  };

  // end of Data Opearations
  //------------------------------------------------------------------------------------------------------------------
  render() {
    return (
      <Drawer
        icon="info-sign"
        position={Position.TOP}
        isOpen={this.props.show}
        onClose={() => {
          this.props.handleHide();
          this.reset();
        }}
        title="Question Pool"
        style={{ height: "90%" }}
        {...this.state}
      >
        <div className={Classes.DRAWER_BODY}>
          <div className={Classes.DIALOG_BODY}>
            {this.state.ErrorDataArranger === false ? (
              this.state.IsDataArranger === false ? (
                <div>
                  {this.state.InOperation !== true &&
                  this.state.IsDataArranger === false ? (
                    <div className={"content"}>
                      <Row>
                        <Col sm={12} md={12}>
                          <Row>
                            <Col sm={12}>
                              <Input
                                placeholder="Google Sheet URL"
                                onChange={this.handleGoogleSheetIDChange}
                                required
                              />
                            </Col>
                          </Row>
                          <br />

                          <Row>
                            <Col sm={12}>
                              <p className="category">
                                <b>Google Sheet ID : </b>
                                {this.state.GoogleSheetID === ""
                                  ? "Please insert valid google sheet URL"
                                  : this.state.GoogleSheetID}
                                {this.state.GoogleSheetID !== "" && (
                                  <i
                                    style={{ color: "green" }}
                                    className="fa fa-check"
                                  />
                                )}
                              </p>
                              <p
                                className="category"
                                style={{ color: "#ff3333" }}
                              >
                                {this.state.GoogleSheetErrorMessage}
                              </p>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    <div className={"content"}>
                      {!this.state.IsDataArranger && (
                        <LoadingMessage
                          OperationMessage={this.state.OperationMessage}
                        />
                      )}
                    </div>
                  )}
                </div>
              ) : (
                this.state.IsDataArranger && (
                  <ArrangedDataView
                    VerifyData={this.VerifyData}
                    ArrangedData={this.state.ArrangedData}
                    show={this.props.show}
                    ModuleName={this.props.ModuleName}
                    ModuleID={this.props.moduleId}
                  />
                )
              )
            ) : (
              <ErrorMessage ErrorMessage={this.state.ErrorMessageDateArrange} />
            )}
          </div>
        </div>
        <div className={Classes.DRAWER_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            {this.state.InOperation !== true &&
              this.state.IsDataArranger === false && (
                <Tooltip content="Fetch data from google sheet">
                  <Button
                    intent="primary"
                    disabled={this.state.loading || !this.state.visible}
                    onClick={this.fetchData}
                    loading={!this.state.visible}
                    text={"Fetch Data"}
                  />
                </Tooltip>
              )}
            {/* Show Verify Button After Data Arranged */}
            {this.state.IsDataArranger === true && (
              <Button
                loading={this.state.dataInserting}
                onClick={this.VerifyData}
                disabled={this.state.dataInserting}
                intent="success"
              >
                Verify
              </Button>
            )}

            <Button
              onClick={() => {
                this.reset();
                this.props.handleHide();
              }}
            >
              Close
            </Button>
          </div>
        </div>
      </Drawer>
    );
  }
}

export default withUseApiService(PaperTypeByGoogle);

function LoadingMessage(props) {
  return (
    <center>
      <h5>
        <Spinner size={30} />
        {props.OperationMessage}
      </h5>
    </center>
  );
}

function ErrorMessage(props) {
  return (
    <center>
      <h5>
        <Icon icon="warning-sign" iconSize={25} intent="warning" />
        <p className="category">{props.ErrorMessage}</p>
      </h5>
    </center>
  );
}
